import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Footer } from "./components/Footer";
import { Nav } from "./components/Nav";
import { useSmoothScroll } from "./hooks/useSmoothScroll";
import { GalleryPage } from "./pages/GalleryPage";
import { HomePage } from "./pages/HomePage";

export function App() {
  useSmoothScroll();

  // Casual media protection: block right-click "Save image as…" and the
  // drag-to-desktop path on every <img> and <video> on the page. This does
  // NOT stop a determined visitor (devtools, screenshots), only the
  // one-tap save flows. Registered globally so it covers every route,
  // including the gallery lightbox.
  useEffect(() => {
    const block = (event: Event) => {
      const target = event.target;
      if (
        target instanceof HTMLImageElement ||
        target instanceof HTMLVideoElement
      ) {
        event.preventDefault();
      }
    };
    document.addEventListener("contextmenu", block);
    document.addEventListener("dragstart", block);
    return () => {
      document.removeEventListener("contextmenu", block);
      document.removeEventListener("dragstart", block);
    };
  }, []);

  return (
    <BrowserRouter>
      <Nav />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/gallery" element={<GalleryPage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
